<!-- Botón para abrir modal -->
<button style="float: right;" class="btn btn-primary" type="button" mdbBtn rounded="true" data-toggle="modal"
  data-target="#basicExample" (click)="frame.show()" mdbWavesEffect>
  {{ 'texto_60' | translate }}
</button>

<!-- Modal -->
<div mdbModal #frame="mdbModal" class="modal fade top" id="frameModalTop" tabindex="-1" role="dialog"
  aria-labelledby="modalTitle" aria-hidden="true">
  <div class="modal-dialog cascading-modal modal-avatar modal-sm" role="document">
    <div class="modal-content">
      <div class="modal-body mx-3" style="padding: 1rem;">
        <div class="card-header card-header-info">
          <h5 class="card-title mb-0" id="modalTitle">{{ 'texto_379' | translate }}</h5>
        </div>

        <button type="button" class="btn btn-dark" style="z-index: 100; float: right; margin-top: -2.8rem;"
          data-dismiss="modal" (click)="frame.hide()" aria-label="Cerrar modal">X</button>

        <form [formGroup]="validatingForm" style="margin-top: 10px;">
          <div class="row">
            <!-- Campo ID -->
            <div class="md-form mb-3 col-md-12">
              <input type="text" id="input-id" class="form-control" formControlName="signupFormModalId" mdbInput
                mdbValidate>
              <label for="input-id">ID. {{ 'texto_101' | translate }}</label>
              <mdb-error *ngIf="signupFormModalId.invalid && (signupFormModalId.dirty || signupFormModalId.touched)">
                {{ 'texto_61' | translate }}
              </mdb-error>
              <mdb-success *ngIf="signupFormModalId.valid && (signupFormModalId.dirty || signupFormModalId.touched)">
                {{ 'texto_62' | translate }}
              </mdb-success>
            </div>

            <!-- Campo Nombre -->
            <div class="md-form mb-3 col-md-12">
              <input type="text" id="input-name" class="form-control" formControlName="signupFormModalName"
                maxlength="255" mdbInput mdbValidate>
              <label for="input-name">N. {{ 'texto_101' | translate }}</label>
              <mdb-error
                *ngIf="signupFormModalName.invalid && (signupFormModalName.dirty || signupFormModalName.touched)">
                {{ 'texto_61' | translate }}
              </mdb-error>
              <mdb-success
                *ngIf="signupFormModalName.valid && (signupFormModalName.dirty || signupFormModalName.touched)">
                {{ 'texto_62' | translate }}
              </mdb-success>
            </div>
          </div>

          <!-- Campo Comentario -->
          <div class="md-form">
            <label for="textarea-comment">{{ 'texto_46' | translate }}</label>
            <mdb-icon fas icon="pencil-alt" class="prefix grey-text" style="margin-top: 10%;"></mdb-icon>
            <textarea id="textarea-comment" class="md-textarea form-control" formControlName="contactFormModalMessage"
              mdbInput maxlength="4000" rows="5" placeholder="{{ 'texto_63' | translate }}">
            </textarea>
            <mdb-error
              *ngIf="contactFormModalMessage.invalid && (contactFormModalMessage.dirty || contactFormModalMessage.touched)">
              {{ 'texto_61' | translate }}
            </mdb-error>
            <mdb-success
              *ngIf="contactFormModalMessage.valid && (contactFormModalMessage.dirty || contactFormModalMessage.touched)">
              {{ 'texto_62' | translate }} </mdb-success>
          </div>

          <!-- Botón de enviar -->
          <div class="text-center mt-3">
            <button type="button" (click)="addTipoRelacion()" mdbBtn rounded="true" class="btn-primary mt-1 waves-light"
              mdbWavesEffect>
              {{ 'texto_60' | translate }}
            </button>
          </div>
        </form>
      </div>
    </div>
  </div>
</div>